module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/piotr-zysik-4869634a81dba2c0420a1d90265d0524.png";